import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getPublicProposals, joinProposal } from '../services/api';

const PublicProposals = () => {
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [joining, setJoining] = useState(null);

  useEffect(() => {
    loadProposals();
  }, []);

  const loadProposals = async () => {
    try {
      const response = await getPublicProposals();
      setProposals(response.data);
    } catch (err) {
      setError('Errore nel caricamento');
    } finally {
      setLoading(false);
    }
  };

  const handleJoin = async (proposalId, availabilityIndex) => {
    setJoining(proposalId);
    try {
      await joinProposal(proposalId, availabilityIndex);
      loadProposals();
    } catch (error) {
      console.error('Error joining proposal:', error);
    } finally {
      setJoining(null);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('it-IT');
  };

  if (loading) return <div className="loading">Caricamento...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="page-container">
      <h1>Proposte pubbliche</h1>
      <p className="page-description">
        Proposte aperte da altri utenti in attesa di un accompagnatore
      </p>

      {proposals.length === 0 ? (
        <p className="empty-state">Nessuna proposta disponibile al momento</p>
      ) : (
        <div className="proposal-list">
          {proposals.map((proposal) => (
            <div key={proposal._id} className="proposal-card proposal-open">
              <div className="proposal-header">
                <Link to={`/targets/${proposal.targetId._id}`} className="proposal-target">
                  {proposal.targetId.name}
                </Link>
                <span className="proposal-organizer">
                  di {proposal.organizerId.username}
                </span>
              </div>

              <div className="proposal-availabilities">
                <p className="availabilities-label">Disponibilita:</p>
                <div className="availability-buttons">
                  {proposal.availabilities.map((av, index) => (
                    <button
                      key={index}
                      onClick={() => handleJoin(proposal._id, index)}
                      className={`btn btn-availability ${av.targetConfirmed ? 'confirmed' : ''}`}
                      disabled={joining === proposal._id}
                    >
                      {formatDate(av.date)} {av.timeSlot}
                      {av.targetConfirmed && (
                        <span className="target-confirmed-badge" title="Persona confermata disponibile">
                          *
                        </span>
                      )}
                    </button>
                  ))}
                </div>
                <p className="availability-hint">
                  * = la persona da visitare ha confermato la disponibilita
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PublicProposals;
